import React from 'react'
import colors from '../../../theme/colors'
import round from '../../../theme/round'

const emptyRow = {
  label: '',
  enabled: true,
  value: '',
  custom: true,
}

export default ({ push }) => (
  <button onClick={() => push(emptyRow)} style={styles.container}>
    +
  </button>
)

const styles = {
  container: {
    color: colors.white,
    backgroundColor: colors.green,
    borderRadius: round,
    width: '40px',
    height: '40px',
    cursor: 'pointer',
    margin: '20px 0 40px -10px',
    outline: 0,
    fontSize: '20px',
    fontWeight: 600,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}
